import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { filter, map } from 'rxjs';

import { NavigationWebService } from '../services/navigation.service';
import { SubscriptionsService } from '../services/subscriptions.service';

export const SubscriptionExistGuard: CanActivateFn = () => {
  const subService = inject(SubscriptionsService);
  const navService = inject(NavigationWebService);
  const router = inject(Router);
  return subService.subscriptionExistingStatus$.pipe(
    filter(status => status !== 'undefined'),
    map(status => {
      if (status === 'exist') {
        return true;
      } else {
        return router.createUrlTree(navService.getChoosePlanSegments());
      }
    }),
  );
};

export const SubscriptionDontExistGuard: CanActivateFn = () => {
  const subService = inject(SubscriptionsService);
  const navService = inject(NavigationWebService);
  const router = inject(Router);
  return subService.subscriptionExistingStatus$.pipe(
    filter(status => status !== 'undefined'),
    map(status => {
      if (status === 'exist') {
        return router.createUrlTree(navService.getBaseSegments());
      } else {
        return true;
      }
    }),
  );
};

export const PaymentFailedGuard: CanActivateFn = () => {
  const subService = inject(SubscriptionsService);
  const navService = inject(NavigationWebService);
  const router = inject(Router);
  return subService.blockPatientsUiByFailedPaymentAndMissingSub$.pipe(
    map(block => {
      if (block) {
        return router.createUrlTree(navService.getPaymentFailedSegments());
      } else {
        return true;
      }
    }),
  );
};
